module.exports = __webpack_public_path__ + "static/media/explorar-unid.33c54846.jpg";